import { cProductItem } from "../components/product-item/product-item";
import { Temporal }     from 'temporal-polyfill';

export class cUtil {

  public static chToUnix(date: string): number {
    const dateFormat = /^(0?[1-9]|[1-2][0-9]|3[0-1])\.(0?[1-9]|1[0-2])\.(\d\d\d\d|\d?\d)$/;
    if(!dateFormat.test(date)) return 0;
    const [all, day, month, year] = dateFormat.exec(date) as RegExpExecArray;
    return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).valueOf();
  }

  public static chToIso(date: string): string {
    const unix = this.chToUnix(date);
    return this.unixToIso(unix);
  }

  public static isoToUnix(date: string): number {
    const dateFormat = /^(\d\d\d\d)-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
    if(!dateFormat.test(date)) return 0;
    const [all, year, month, day] = dateFormat.exec(date) as RegExpExecArray;
    return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).valueOf();
  }

  public static isoToCh(date: string): string {
    const dateFormat = /^(\d\d\d\d)-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
    if(!dateFormat.test(date)) return '01.01.1970';
    const [all, year, month, day] = dateFormat.exec(date) as RegExpExecArray;
    return `${day}.${month}.${year}`;
  }

  public static unixToCh(dateNum: number) {
    return new Date(dateNum).toLocaleDateString('de-CH', {day: '2-digit', month: '2-digit', year: 'numeric'});
  }

  public static unixToIso(dateNum: number) {
    const date  = new Date(dateNum);
    const year  = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day   = String(date.getDate()     ).padStart(2, '0');    
    return `${year}-${month}-${day}`;
  }

  public static currentIsoDateCET() {
    return Temporal.Now.zonedDateTimeISO("Europe/Zurich").toString().slice(0, 10);
  }

  public static validateCh(date: string): boolean {
    const dateFormat = /^(0?[1-9]|[1-2][0-9]|3[0-1])\.(0?[1-9]|1[0-2])\.(\d\d\d\d|\d?\d)$/;
    return dateFormat.test(date);
  }

  // Kaufmännisch auf 5 Rappen, the counterpart of \c\swissRound() in PHP. Math.round() alone rounds
  // -0.5 towards zero, so the sign is taken out first. The result is put back onto two decimals: a
  // 0.05 step never has more, but 3 * 0.05 is 0.15000000000000002.
  public static swissRound(value: number): number {
    const steps = Math.sign(value) * Math.round(Math.abs(value) / 0.05);
    return Number((steps * 0.05).toFixed(2));
  }

  public static labelIds(label: HTMLLabelElement, elm: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) {
    const id1 = cUtil.rand();
    label.setAttribute('for', 'i' + id1);
    elm.id = 'i' + id1;
  }

  public static url(dest: string): string {
    const html     = document.querySelector('html') as HTMLHtmlElement;
    const langFull = html.lang ?? 'de';
    const lang     = langFull === 'fr-FR' ? '/fr' : '';
    return lang + dest;
  }

  public static urlP(dest: string): string {
    const html = document.querySelector('html') as HTMLHtmlElement;
    if ((html.lang ?? '') === 'fr-FR') {
      const urlParams = new URLSearchParams(dest);
      urlParams.set('lang', 'fr_FR');
      return dest + '?' + urlParams.toString();
    }
    return dest;
  }

  public static rand(): string {
    return String(Math.floor(Math.random() * Number.MAX_SAFE_INTEGER));
  }

  public static locale() {
    const html = document.querySelector('html') as HTMLHtmlElement;
    const lang = html.lang ?? 'de';
    return lang === 'fr-FR' ? 'fr' : 'de';
  }

  public static checkPage(selector: string): boolean {
    // Customizer screens:
    if (wp?.customize?.control !== undefined) return false;
    const elm = document.querySelector(selector);
    return elm !== null
  }

  public static log(message: string) {
    const formData = new FormData();
    formData.append('message', message);
    formData.append('agent'  , navigator.userAgent);
    fetch('/c-errors', {
      method: 'POST',
      body: formData,
    });
  }
    public static logAtEnd(message: string) {
    return; //  todo-deploy
    const parent = document.querySelector('body') as HTMLElement;
    const p      = document.createElement('p');
    parent.append(p);
    p.innerText = message;
    cUtil.log(message);
  }

  public static isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  public static customerPickUp(): boolean {
    const body  = document.querySelector('body') as HTMLElement;
    const isPickUp = body.classList.contains('c-pick-up');
    return isPickUp;
  }

  /*
   * Enter springt ins nächste Feld, in der Reihenfolge der Tab-Taste, statt das Formular abzusenden.
   * Im Warenkorb löste Enter sonst den ersten Submit-Knopf aus, "Gutschein anwenden", und WooCommerce
   * ersetzte das Formular samt Artikeln. In Textareas bleibt Enter ein Zeilenumbruch. Beim letzten
   * Feld passiert nichts. Für Warenkorb, Produktseite und Bestellliste.
   */
  public static enterToNextField(container: HTMLElement): void {
    container.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key !== 'Enter' || e.isComposing) return;

      const target = e.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (target instanceof HTMLInputElement && ['button', 'submit', 'reset', 'image'].includes(target.type)) return;

      e.preventDefault();

      const fields = cUtil.enterTargets(container);
      const index  = fields.indexOf(target);
      if (index === -1) return;
      fields[index + 1]?.focus();
    });
  }

  /*
   * Die Ziele von enterToNextField() in der Reihenfolge der Tab-Taste: zuerst positive tabIndex
   * aufsteigend, dann tabIndex 0 in der Reihenfolge des Dokuments. Eingabefelder, Checkboxen und
   * Auswahllisten, ohne Knöpfe, deaktivierte und unsichtbare Felder. Textareas sind kein Ziel, aus
   * ihnen führt Enter nicht weiter.
   */
  private static enterTargets(container: HTMLElement): (HTMLInputElement | HTMLSelectElement)[] {
    const skip   = ['hidden', 'button', 'submit', 'reset', 'image'];
    const fields =
      Array.from(container.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input, select'))
      .filter(field =>
        !field.disabled &&
        field.tabIndex >= 0 &&
        !(field instanceof HTMLInputElement && skip.includes(field.type)) &&
        field.getClientRects().length > 0 &&
        getComputedStyle(field).visibility !== 'hidden'
      );

    return [
      ...fields.filter(field => field.tabIndex > 0).sort((a, b) => a.tabIndex - b.tabIndex),
      ...fields.filter(field => field.tabIndex === 0),
    ];
  }

  public static gaSaveData(
    productItems : cProductItem[], 
    event        : 'view_item' | 'add_to_cart' | 'remove_from_cart',
    trigger      : 'single-product' | 'order-list' | 'cart',
    listName     : string
  ) { 

    if (productItems.length === 0) return;

    let items = 
      productItems
      .map(item => {
        const amounts     = item.amounts.calculateAmounts();
        const totalAmount = amounts.totalAmount > 0 ? amounts.totalAmount : 1;
        const price       = amounts.price; // todo-later

        return {
          item_id        : item.inputData.product.sku,
          item_name      : item.inputData.product.name,
          item_list_name : listName,
          price          : Number((price * totalAmount).toFixed(2)),
          quantity       : 1,
          currency       : 'CHF',
        }
      })

    if (trigger === 'order-list') {
      items = items.filter(item => item.quantity !== 0);
    }

    const value = 
      items
      .map(item => (item.quantity > 0 ? item.quantity : 1) * item.price)
      .reduce((acc, current) => acc = acc + current);

    const gaData = {
      event    : event, // proprietary, must be removed bevore sending.
      currency : 'CHF',
      value    : value.toFixed(2),
      items    : items,
    };

    sessionStorage.setItem('c-gtag-pending', JSON.stringify(gaData));
  }

  public static gaSendFromStorage() {
    const gaDataJson = sessionStorage.getItem('c-gtag-pending');
    if (gaDataJson !== null) {
      const gaData = JSON.parse(gaDataJson);
      const event  = gaData.event;
      delete gaData.event;
      sessionStorage.removeItem('c-gtag-pending');
      window.gtag('event', event, gaData);
    }
  }
}
